import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteFontDocument } from './delete.generated';

export const useDeleteFont = (options: ApiOptions<typeof DeleteFontDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteFontDocument, {
    ...useNotifications(DeleteFontDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.fonts.delete_success'),
    }),

    update(cache, { data }) {
      if (data?.deleteFont?.font == null) return;
      cache.evict({ id: cache.identify(data.deleteFont.font) });
    },

    ...options,
  });
};
